import { Badge, Button } from "antd";
import React, { useEffect, useRef } from 'react';
import { useDispatch } from "react-redux";
import { RouteService } from "../../../../util/services/route";
import { useSelector } from "../../../../util/store/store";
import { routeActions } from "../../reducer";
import { openAutoRoute } from "../PopupAutoRoute";

interface IProps {
    source?: {
        sea_position?: {
            latitude: number
            longitude: number
        },
        position?: {
            latitude: number
            longitude: number
        }
    },
    destination?: {
        sea_position?: {
            latitude: number
            longitude: number
        },
        position?: {
            latitude: number
            longitude: number
        }
    }
}

const AutoRoute: React.FC<IProps> = ({ source, destination }) => {
    const license = useSelector(state => state.login.user.tenant.auto_route_license);
    const loadingAuto = useSelector(state => state.route.loadingAuto);
    const requestId = useSelector(state => state.route.requestId);
    const abort = useRef(new AbortController());
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            abort.current.abort();
            dispatch(routeActions.autoRouteFailure({}))
        }
    }, [dispatch]);

    useEffect(() => {
        if (!loadingAuto) return;

        const timer = setTimeout(() => {
            abort.current.abort();
            dispatch(routeActions.autoRouteFailure({ message: 'Auto route timed out after 5 minutes.' }));
        }, 5 * 60 * 1000);

        return () => clearTimeout(timer);
    }, [dispatch, loadingAuto, requestId]);

    if (!license)
        return <div />

    const openAutoRouteSetting = () => {
        if (loadingAuto || !source || !destination)
            return;

        openAutoRoute({
            onOk: ({ avoid_disease }) => {
                const {
                    latitude: source_lat = 0,
                    longitude: source_lng = 0
                } = source.position || {};
                const {
                    latitude: destination_lat = 0,
                    longitude: destination_lng = 0
                } = destination.position || {};

                const body = {
                    departure: {
                        position: `${source_lat} ${source_lng}`,
                        port: {}
                    },
                    arrival: {
                        position: `${destination_lat} ${destination_lng}`,
                        port: {}
                    },
                    avoid_disease,
                    request_id: ['auto-route', Date.now()].join('-'),
                }
                dispatch(routeActions.autoRouteRequest(body));
                const controller = new AbortController();
                abort.current = controller;
                RouteService.callAutoRoute(body, controller)
                    .catch(error => {
                        if (!controller.signal.aborted) {
                            dispatch(routeActions.autoRouteFailure(error));
                        }
                    });
            }
        })
    }

    return <Badge count="Beta" color="orange" styles={{ indicator: { height: 18, lineHeight: "18px" } }}>
        <Button type="link" loading={loadingAuto} onClick={openAutoRouteSetting}>
            <span className="link">Auto route</span>
        </Button>
    </Badge>
};

export default AutoRoute;
